/**
 * @desc 刷新accessToken有效时间
 */
const URL = "/rantion-auth";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/accessToken/renew`, {
      method: "POST",

      ...options,
    }),
  );
}
